import { Buildings, HandCoins, TrendUp } from "@phosphor-icons/react";

const money = (n) => `$${(Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const OUTCOME_LABELS = {
  got_discount: "Got discount",
  no_discount: "No discount",
  switched_vendors: "Switched vendors",
};

export function VendorInsightCard({ insight, index, showBusinessName = false, onDraft, testIdPrefix = "vendor-insights" }) {
  return (
    <article className="bk-card p-6 space-y-4 bk-lift" data-testid={`${testIdPrefix}-card-${index}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <h4 className="font-display text-2xl font-bold" style={{ color: "var(--bk-text)" }} data-testid={`${testIdPrefix}-vendor-name-${index}`}>
            {insight.vendor_name}
          </h4>
          {showBusinessName && (
            <p className="text-sm mt-1 inline-flex items-center gap-1.5" style={{ color: "var(--bk-text-2)" }} data-testid={`${testIdPrefix}-business-name-${index}`}>
              <Buildings size={14} weight="duotone" /> {insight.business_name}
            </p>
          )}
        </div>
        <div className="flex flex-wrap justify-end gap-2">
          {insight.spend_over_threshold && (
            <span className="px-3 py-1 rounded-full text-xs font-semibold" style={{ background: "var(--bk-rowan-bg)", color: "var(--bk-accent)" }} data-testid={`${testIdPrefix}-loyalty-badge-${index}`}>
              Loyalty leverage
            </span>
          )}
          {insight.price_increase_flag && (
            <span className="px-3 py-1 rounded-full text-xs font-semibold" style={{ background: "#FDECE8", color: "#B23B1F" }} data-testid={`${testIdPrefix}-price-badge-${index}`}>
              Prices rising
            </span>
          )}
        </div>
      </div>

      <div className="rounded-2xl p-4 border" style={{ borderColor: "rgba(232,168,56,0.24)", background: "var(--bk-rowan-bg)" }} data-testid={`${testIdPrefix}-rowan-callout-${index}`}>
        <p className="text-sm font-semibold leading-relaxed" style={{ color: "var(--bk-text)" }}>{insight.rowan_primary}</p>
        <p className="text-xs mt-2 italic" style={{ color: "var(--bk-text-2)" }}>
          {insight.rowan_voice_lines?.[0]}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="rounded-2xl p-4" style={{ background: "#F8F7F4" }} data-testid={`${testIdPrefix}-annual-spend-${index}`}>
          <p className="text-xs uppercase tracking-[0.16em] font-semibold" style={{ color: "var(--bk-text-2)" }}>Annual spend</p>
          <p className="font-display text-2xl font-bold mt-2" style={{ color: "var(--bk-text)" }}>{money(insight.annual_spend)}</p>
        </div>
        <div className="rounded-2xl p-4" style={{ background: "#F8F7F4" }} data-testid={`${testIdPrefix}-recent-quarter-${index}`}>
          <p className="text-xs uppercase tracking-[0.16em] font-semibold" style={{ color: "var(--bk-text-2)" }}>Last 90 days</p>
          <p className="font-display text-2xl font-bold mt-2" style={{ color: "var(--bk-text)" }}>{money(insight.recent_90_total)}</p>
        </div>
        <div className="rounded-2xl p-4" style={{ background: "#F8F7F4" }} data-testid={`${testIdPrefix}-price-change-${index}`}>
          <p className="text-xs uppercase tracking-[0.16em] font-semibold" style={{ color: "var(--bk-text-2)" }}>Quarter trend</p>
          <p className="font-display text-2xl font-bold mt-2 inline-flex items-center gap-2" style={{ color: insight.price_increase_flag ? "#B23B1F" : "var(--bk-success)" }}>
            <TrendUp size={18} weight="duotone" /> {insight.price_increase_flag ? `+${insight.price_increase_pct}%` : "Stable"}
          </p>
        </div>
      </div>

      <div className="rounded-2xl border p-4" style={{ borderColor: "var(--bk-border)", background: "#fff" }} data-testid={`${testIdPrefix}-alternatives-${index}`}>
        <div className="flex items-center gap-2 mb-2">
          <HandCoins size={17} weight="duotone" color="var(--bk-success)" />
          <p className="text-sm font-semibold" style={{ color: "var(--bk-text)" }}>Alternative vendor research</p>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: "var(--bk-text-2)" }}>{insight.alternatives?.note}</p>
        <ul className="mt-3 space-y-1 text-sm" style={{ color: "var(--bk-text)" }}>
          {(insight.alternatives?.alternatives || []).map((item) => <li key={item}>• {item}</li>)}
        </ul>
        <p className="text-xs mt-3" style={{ color: "var(--bk-text-2)" }}>{insight.alternatives?.comparison_prompts?.[0]}</p>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="text-xs" style={{ color: "var(--bk-text-2)" }} data-testid={`${testIdPrefix}-negotiation-status-${index}`}>
          {insight.latest_negotiation?.outcome
            ? <>Latest outcome: <span className="font-semibold" style={{ color: "var(--bk-text)" }}>{OUTCOME_LABELS[insight.latest_negotiation.outcome] || insight.latest_negotiation.outcome}</span></>
            : insight.latest_negotiation?.status === "sent"
            ? <>Negotiation email sent. Now go see what they say.</>
            : <>No negotiation tracked yet.</>}
        </div>
        <button onClick={() => onDraft(insight)} data-testid={`${testIdPrefix}-draft-button-${index}`} className="bk-btn-primary px-5 py-2.5 text-sm font-semibold">
          Draft Loyalty Discount Request
        </button>
      </div>
    </article>
  );
}